import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { Row } from "@tanstack/react-table";
import { MoreHorizontal } from "lucide-react";
import { ModalRequest } from "./modal/modal-request";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const { handleModal } = useDialogModal();

  const handleOpenModal = () => {
    handleModal({
      isOpen: true,
      element: <ModalRequest requestData={row.original} />,
      title: "Detalhes da Requisição",
    });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost_none"
          className="flex h-8 w-8 p-0 data-[state=open]:bg-muted border-none bg-transparent"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal />
          <span className="sr-only">Abrir Menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        <DropdownMenuItem onClick={handleOpenModal}>
          Ver Detalhes
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
